/**
 * useWishlist Hook
 * Manages a single wishlist with real-time updates
 */

import { useEffect, useState } from 'react'
import { Wishlist } from '@/types'
import { subscribeToWishlist } from '@/services/wishlist.service'

export function useWishlist(wishlistId: string | undefined) {
  const [wishlist, setWishlist] = useState<Wishlist | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!wishlistId) {
      setWishlist(null)
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    const unsubscribe = subscribeToWishlist(wishlistId, wishlist => {
      setWishlist(wishlist)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [wishlistId])

  return {
    wishlist,
    loading,
    error,
  }
}
